import React, { useEffect } from 'react';
import {
  FIREBOLT_DESTINATION_CONSIDERATIONS_DOC_LINK
} from '../constants/constants';
import useSettingsStorageService from '../../../auth/hooks/useSettingsStorageService';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import HdModal from '../../../modal/components/modal/HdModal';
import { HdButton, HdDocLink, HdIcon, HdIconButton } from '../../../components';
import useAnalyticsTracker from '../../../analytics/hooks/useAnalyticsTracker';
import { TRACKER_WARNING_DIALOG_CREATE_TABLE_CLICK } from '../tracking/schemaBuilderTracking';

export function FireboltWarningDialog({ onClose, open = false, onConfirm }) {
  const settingsStorageService = useSettingsStorageService();
  const { eventTrack } = useAnalyticsTracker();

  useEffect(() => {
    settingsStorageService.applySettings('CREATE_TABLE_WARNING_DIALOG_SHOWN', true);
  }, []);

  const handleConfirmClick = () => {
    eventTrack({
      action: TRACKER_WARNING_DIALOG_CREATE_TABLE_CLICK
    });
    onConfirm();
  };

  const dataIdGenerator = getDataIdGenerator('create-schema-warning');

  return (
    <HdModal open={open}>
      <div className='dialog-content'>
        <div className='dialog-header dialog-header--absolute'>
          <HdIconButton
            onClick={() => onClose()}
            dataId={dataIdGenerator('close')}
          >
            <HdIcon name='close' />
          </HdIconButton>
        </div>

        <div className='dialog-body no-item-box warning m-0'>
          <div className='no-item-box-icon-container'>
            <HdIcon name='warning' className='no-item-box-icon' />
          </div>

          <span className='no-item-box-title text-bold'>Note</span>

          <span className='no-item-box-desc mb-1'>
            Tables once created cannot be altered because of technical limitations. Please refer to
            documentation for more details.
            <HdDocLink
              className='ml-1'
              dataId={dataIdGenerator('firebolt-destination-considerations')}
              section='firebolt_destination_considerations'
              docLink={FIREBOLT_DESTINATION_CONSIDERATIONS_DOC_LINK}
            />
          </span>

          <HdButton
            onClick={() => handleConfirmClick()}
            className='mt-6'
            dataId={dataIdGenerator('create-table')}
          >
            Create Table
          </HdButton>
        </div>
      </div>
    </HdModal>
  );
}
